import { Routes } from "@angular/router";
import { DashboardComponent } from "../../views/commons/dashboard/dashboard.component";
import { ContentSearchComponent } from "../../views/vod/content-search/content-search.component";
import { ContentGridComponent } from "../../views/vod/content-grid/content-grid.component";
import { ChannelGridComponent } from "../../views/btv/channel-grid/channel-grid.component";
import { TvGuideComponent } from "../../views/btv/tv-guide/tv-guide.component";
import { ContentListComponent } from "../../views/vod/content-list/content-list.component";
import { PodcastDetailComponent } from "../../views/podcast/podcast-detail/podcast-detail.component";
import { ContentDetailComponent } from "../../views/vod/content-detail/content-detail.component";
import { PodcastGridComponent } from "../../views/podcast/podcast-grid/podcast-grid.component";
import { ChannelDetailComponent } from "../../views/btv/channel-detail/channel-detail.component";
import { BlogGridComponent } from "../../views/blog/blog-grid/blog-grid.component";
import { BlogDetailComponent } from "../../views/blog/blog-detail/blog-detail.component";
import { BlogContentComponent } from "../../views/blog/blog-content/blog-content.component";

export const PUBLIC_ROUTES: Routes = [
  { path: "", redirectTo: "dashboard", pathMatch: "full" },
  { path: "dashboard/:id/:urlName", component: DashboardComponent },
  { path: "dashboard", component: DashboardComponent },
  { path: "contentGrid/:id/:labelName", component: ContentGridComponent },
  { path: "contentList", component: ContentListComponent },
  { path: "channelList/:id", component: ChannelGridComponent },
  { path: "contentSearch/:query", component: ContentSearchComponent },
  { path: "podcastDetail/:id", component: PodcastDetailComponent },
  { path: "contentDetail/:id/:urlName", component: ContentDetailComponent },
  { path: "canli/:id", component: ChannelDetailComponent },
  { path: "podcastGrid/:id", component: PodcastGridComponent },
  { path: "blogGrid/:id", component: BlogGridComponent },
  { path: "blogDetail/:id", component: BlogDetailComponent },
  { path: "blog/:blogId/content/:id", component: BlogContentComponent },
  { path: "canli-yayin", redirectTo: "canli/sportstv", pathMatch: "full" },
  { path: "ozel/yayin-akisi", redirectTo: "canli/sportstv" },
  { path: "**", redirectTo: "dashboard" },
];



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/layouts/public/public.routes.ts